import {mutations} from "@/modules/ProjectManager/store/mutations";
import {actions} from "@/modules/ProjectManager/store/actions";
import {getters} from "@/modules/ProjectManager/store/getters";

const state = {

    projectsLoading: false,
    projectsCacheExpires: null,
    projects: [],
    prominentProject: null,

    projectQuotas: [],
    projectQuotasCacheExpires: null,

    activeTabModel: 0,

    activeTableSearch: '',

    activeTableOptions: {
        page: 1,
        sortBy: ['completed_percent'],
        sortDesc: [true],
        itemsPerPage: 20,
        mustSort: true,
    },

    activeTableFilters: [
        {type: 'responsible', name: 'Responsible for', icon: 'mdi-account', color: "white", model: true, divider: false},
        {type: 'mine', name: 'Managed by me', icon: "mdi-account", color: "white", model: false},
        {type: 'others', name: 'Managed by others', icon: "mdi-account-group", color: "white", model: false, divider: true},
        {type: 'user-managed', name: 'Managed by user(s)', icon: "mdi-account-multiple-check", color: "white", model: false, ids: []},
        {type: 'user-responsible', name: 'Responsible by user(s)', icon: "mdi-account-multiple-check", color: "white", model: false, ids: []},
        {type: 'online', name: 'Online', icon: "mdi-circle-medium", color: "green", model: false, divider: true},
        {type: 'offline', name: 'Offline', icon: "mdi-circle-medium", color: "red", model: false},
        {type: 'paused', name: 'Paused', icon: "mdi-circle-medium", color: "primary", model: false},
        {type: 'closed', name: 'Closed', icon:"mdi-circle-medium", color:"red", model: false},
    ],

    archivedProjects: [],
    archivedTableSearch: '',
    archivedTableOptions: {
        page: 1,
        sortBy: ['end_date'],
        sortDesc: [true],
        itemsPerPage: 10,
        mustSort: true
    },

    categoriesLoading: false,
    categoriesCacheExpires: null,
    categories: [],

    projectErrors: [],

    projectStats: [],
    projectStatsLoading: false,
    projectStatsCacheExpires: null,

    projectGeoStats: [],
    projectGeoStatsLoading: false,
    projectGeoStatsCacheExpires: null,

    gallery: [],
    galleryCacheExpires: null,

    recontactParticipants: [],
    selectedSubPanelIds: [],
}

export default {
    namespaced: true,

    state,
    getters,
    actions,
    mutations
}

